<div class="signin-shell">
  <div class="signin-glow signin-glow--pink"></div>
  <div class="signin-glow signin-glow--blue"></div>

  <div class="signin-card">
    <section class="signin-panel signin-panel--visual">
      <video
        class="signin-video"
        autoplay
        muted
        loop
        playsinline
        aria-label="Sign In Video"
      >
        <source
          src="https://sharajman.com/wp-content/uploads/2026/04/nea-login.mp4"
          type="video/mp4"
        />

        <track
          kind="subtitles"
          srclang="en"
          label="English"
          default
        />

        <track
          kind="descriptions"
          srclang="en"
          label="English description"
        />
      </video>

      <div class="signin-overlay overlay"></div>

      <div class="signin-visual-content">
        <div class="signin-pill">
          Nepal Electricity Authority
        </div>

        <div class="signin-copy">
          <p class="signin-copy__eyebrow">Welcome to</p>
          <h1>PSOD Portal</h1>
          <p>
            A web based portal (WSP), bridging Stakeholders &
            PSOD
          </p>
        </div>
      </div>
    </section>

    <section class="signin-panel signin-panel--form">
      <div class="signin-brand">
        <img [src]="logoPath" alt="Nepal Electricity Authority Logo" />
      </div>

      <div class="signin-heading">
        <h2>Welcome Back</h2>
        <p>Enter your username and password to access your account</p>
      </div>

      <form
        class="signin-form"
        [class.signin-form--has-message]="error || loginSuccess"
        (ngSubmit)="onSignin()"
      >
        <div class="field-group">
          <div class="field-group__head">
            <label for="username">Username</label>
          </div>

          <div class="field-group__body">
            <input
              id="username"
              name="username"
              type="text"
              [(ngModel)]="username"
              placeholder="Enter your username"
              autocomplete="username"
            />
          </div>
        </div>

        <div class="field-group">
          <label for="password">Password</label>
          <div class="password-field">
            <input
              id="password"
              name="password"
              [type]="showPassword ? 'text' : 'password'"
              [(ngModel)]="password"
              placeholder="Enter your password"
              autocomplete="current-password"
            />

            <button
              type="button"
              class="password-toggle"
              (click)="togglePasswordVisibility()"
              [attr.aria-label]="
                showPassword ? 'Hide password' : 'Show password'
              "
            >
              @if (showPassword) {
                <span><i class="fa-solid fa-eye-slash"></i></span>
              } @else {
                <span><i class="fa-solid fa-eye"></i>
</span>
              }
            </button>
          </div>
        </div>
        <div class="field-group">
          <div class="field-group__head">
            <label for="captchaResponse"></label>
            <button
              type="button"
              class="captcha-refresh"
              [disabled]="captchaLoading"
              (click)="refreshCaptcha()"
            >
              Refresh
            </button>
          </div>

          <div class="captcha-box">
            <div class="captcha-box__image" aria-label="CAPTCHA image">
              @if (captchaImage) {
                <img [src]="captchaImage" alt="CAPTCHA code" />
              } @else {
                <span>{{ captchaLoading ? 'Loading...' : 'CAPTCHA unavailable' }}</span>
              }
            </div>
            <input
              id="captchaResponse"
              name="captchaResponse"
              type="text"
              [(ngModel)]="captchaResponse"
              placeholder="Enter CAPTCHA"
              autocomplete="off"
              maxlength="12"
            />
          </div>
        </div>
       

        <div class="signin-meta">
          <label class="remember-me">
            <input
              type="checkbox"
              [(ngModel)]="rememberMe"
              name="rememberMe"
              (change)="onChangeRememberMe($event.target.checked)"
            />
            <span>Remember me</span>
          </label>

          <button
            type="button"
            class="link-button"
            (click)="goToForgotPassword()"
          >
            Forgot Password
          </button>
        </div>

          @if (error) {
          <div class="message message--error">
            {{ error }}
          </div>
        }

        @if (loginSuccess) {
          <div class="message message--success">
            Sign in details accepted.
          </div>
        }

        <button type="submit" class="signin-submit">
          Sign In
        </button>

      </form>
    </section>
  </div>
</div>
